import { useEffect, useState } from "react";
import { motion, useScroll, useTransform, useSpring } from "framer-motion";

export const FloatingToilet = () => {
  const [vw, setVw] = useState(() => (typeof window !== "undefined" ? window.innerWidth : 1200));

  useEffect(() => {
    const onResize = () => setVw(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const { scrollYProgress } = useScroll();
  const start = vw < 640 ? 0.03 : -0.15;
  const rawX = useTransform(scrollYProgress, (p) => (start + p * (0.98 - start)) * vw);
  const x = useSpring(rawX, { stiffness: 55, damping: 16, mass: 0.6 });

  return (
    <motion.img
      src="/images/toilet-mascot.png"
      alt="Master Blaster toilet mascot"
      data-testid="floating-toilet"
      style={{ x }}
      className="fixed bottom-4 sm:bottom-6 left-0 z-30 w-28 sm:w-44 pointer-events-none select-none drop-shadow-[0_10px_16px_rgba(11,19,43,0.2)]"
    />
  );
};
